import { ChangeDetectorRef, Directive, ElementRef, HostBinding } from '@angular/core';

import { WindowRefService } from '@hdms/shared/util-core';

import { VisibilityComponentAbstract } from '../shared/visibility-component.abstract';

@Directive()
export abstract class LeftCardComponentAbstract extends VisibilityComponentAbstract {
  protected abstract cardContainer: ElementRef<HTMLDivElement>;

  @HostBinding('class.is-open')
  get classIsOpen(): boolean {
    return this.isOpen;
  }
  @HostBinding('class.d-none')
  get classDisplayNone(): boolean {
    return this.isHidden;
  }

  protected constructor(win: WindowRefService, cdr: ChangeDetectorRef) {
    super(win, cdr);
  }

  transitionEndHandler(e: Event): void {
    if (!this.isOpen && e.target === this.cardContainer.nativeElement) {
      this.onClosed();
    }
  }
}
